// Internal routes, external links, nav, and contact info for Wallstreet Realty
export const ROUTES = {
  home: "/",
  // IDX home search lives at /idx (iHomeFinder Kestrel renders search,
  // results, and property detail pages under this path).
  search: "/idx",
  idx: "/idx",
  buy: "/buy",
  sell: "/sell",
  join: "/join",
  contact: "/contact",
  about: "/about",
  financing: "/financing",
  areas: "/areas",
  agents: "/agents",
  blog: "/blog",
};

// Primary CTAs route to internal pages (Btn auto-detects "/" as internal Link).
export const LINKS = {
  idx: ROUTES.idx,
  buyers: ROUTES.buy,
  join: ROUTES.join,
  sellers: ROUTES.sell,
  contact: ROUTES.contact,
  financing: ROUTES.financing,
};

export const CONTACT = {
  phone: "(562) 600-3756",
  phoneTel: "+15626003756",
  email: "john@wallstrealty.com",
  address: "Serving Los Angeles County, Orange County & all of Southern California",
  broker: "John Pagani, Broker",
  dre: "DRE LIC #01926616",
};

export const NAV = [
  { label: "Home", href: ROUTES.home },
  { label: "Buy", href: ROUTES.buy },
  { label: "Sell", href: ROUTES.sell },
  { label: "Search Homes", href: ROUTES.idx },
  { label: "Financing", href: ROUTES.financing },
  { label: "Areas", href: ROUTES.areas },
  { label: "Agents", href: ROUTES.agents },
  { label: "Join Wallstreet Realty", href: ROUTES.join },
  { label: "Blog", href: ROUTES.blog },
  { label: "Contact", href: ROUTES.contact },
];
